
namespace RioERP.Enquiry {
    export class PendingOrderProductsColumns {
        static columnsKey = 'Enquiry.PendingOrderProducts';
    }
}